.selectCell {
	display: flex;
	align-items: center;
	justify-content: center;
}

.oaCard {
	display: flex;
	flex-direction: column;
	gap: 0.35rem;
	width: 100%;
	min-width: 0;
	padding: 0.45rem 0.5rem;
	border: 1px solid #e5e7eb;
	border-radius: 12px;
	background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.oaCardBody {
	display: flex;
	flex-direction: column;
	gap: 0.35rem;
}

.oaIdentity {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.28rem;
	min-width: 0;
}

.oaStatus {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.28rem;
	min-width: 0;
	padding-top: 0.35rem;
	border-top: 1px solid #f3f4f6;
}

.oaCode {
	font-size: 0.92rem;
	font-weight: 800;
	color: #111827;
	line-height: 1.2;
	white-space: nowrap;
}

.oaUsage {
	display: flex;
	flex-direction: row;
	align-items: baseline;
	gap: 0.3rem;
	white-space: nowrap;
}

.oaUsageLabel {
	font-size: 0.68rem;
	font-weight: 500;
	color: #6b7280;
	line-height: 1.2;
	white-space: nowrap;
}

.oaUsageValue {
	font-size: 0.88rem;
	font-weight: 700;
	color: #1f2937;
	line-height: 1.2;
	font-variant-numeric: tabular-nums;
	white-space: nowrap;
}

.oaUsageValueComplete {
	color: #16a34a;
}

.oaInternalCode {
	font-size: 0.72rem;
	color: #4b5563;
	line-height: 1.3;
	padding-top: 0.15rem;
	border-top: 1px solid #f3f4f6;
}

.oaField {
	font-weight: 600;
	color: #1f2937;
}

.centerCard {
	display: flex;
	flex-direction: column;
	gap: 0.2rem;
	padding: 0.35rem 0.45rem;
	border: 1px solid #e5e7eb;
	border-radius: 8px;
	background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
	min-width: 0;
	flex: 1 1 45%;
	max-width: 100%;
}

.centerHeader {
	display: flex;
	align-items: center;
	gap: 0.35rem;
	font-size: 0.72rem;
	font-weight: 700;
	color: #475569;
	text-transform: uppercase;
	letter-spacing: 0.03em;
}

.centerName {
	display: flex;
	align-items: center;
	gap: 0.35rem;
	font-size: 0.82rem;
	font-weight: 700;
	color: #111827;
}

.centerMeta {
	display: flex;
	gap: 0.35rem;
	flex-wrap: wrap;
}

.numericRight {
	width: 100%;
	text-align: right;
}

.alignCenter {
	display: flex;
	align-items: center;
}

.actionsHeader {
	width: 100%;
	text-align: center;
}

.actionsCell {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	min-height: 100%;
}
